<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 数字家园管理系统轮播图 -->
    <AdminBanner></AdminBanner>
    <!-- 行业痛点 物业难题 -->
    <Painpoint></Painpoint>
    <!-- 物业APP -->
    <PropertyApp></PropertyApp>
    <!-- 业主APP -->
    <OwnerApp></OwnerApp>
    <!-- 后台管理 -->
    <Backstage></Backstage>
    <!-- 智能软件系统 -->
    <Hardware></Hardware>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import AdminBanner from '../../../../components/pc/Product/AdminSystemComponents/AdminBanner.vue'
import Painpoint from '../../../../components/pc/Product/AdminSystemComponents/Painpoint.vue'
import PropertyApp from '../../../../components/pc/Product/AdminSystemComponents/PropertyApp.vue'
import OwnerApp from '../../../../components/pc/Product/AdminSystemComponents/OwnerApp.vue'
import Backstage from '../../../../components/pc/Product/AdminSystemComponents/Backstage.vue'
import Hardware from '../../../../components/pc/Home/Hardware.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    AdminBanner,
    Painpoint,
    PropertyApp,
    OwnerApp,
    Backstage,
    Hardware
  },
};
</script>

<style scoped>

</style>
